import React, { useEffect, useState } from "react";
import { shallowEqual, useSelector, useDispatch } from "react-redux";
import { useNavigate } from 'react-router-dom';
import BasePage from "./basePage";
import LoginBasePage from "./loginBasePage";
import { updateFirstRun } from "../../actions/firstRunAction";
import { getAllNotification } from "../../actions/notificationAction";
import { getProductAndPlanDetails } from "../../actions/product_details_action";
import { getUserInfo } from "../../actions/loginActions";
import { getWidgetWallData } from '../../actions/wallDataAction'; 
import { USER_STUDIO_WALL } from "../../actions/sceneActions";
import { WALL_ROUTES } from "../../actions/constant";
import LoadingScreen from "../CommonComponents/LoadingScreen";
import withRouter from "../CommonComponents/WithRouter";
import { getWallFeeds } from "../../actions/analyticsAction";
import CookieConsent from "./CookieConsent";


const ProtectedRoute = ({getProps, history}) => {
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    setTimeout(() => setLoading(false), 2000);
  }, [])
  return loading ? <LoadingScreen /> : <BasePage getProps={getProps} history={history} />
}



const RoutesExtends = (props) => {
  const dispatch = useDispatch();
  const history = useNavigate();
  const getProps = useSelector((state) => state, shallowEqual);
  const { firstRun } = getProps.firstRun;
  const path = window.location.pathname;
  const studioUrl = path.split("/");
  const conditions = WALL_ROUTES;
  
  // verifyemail / redirectlogin / confirmaccount pe token abhi issue ho raha hota hai.
  // Yahan bootstrap chal gaya to getUserInfo naya token bana deti hai aur usi waqt chal rahi
  // baaki requests (details / feeds / notification / plan) purane token ke saath 419 ho jaati hain.
  // Ye flows khud redirect ke baad firstRun dispatch karte hain.
  const isAuthFlow = ['verifyemail', 'redirectlogin', 'confirmaccount'].some(el => path.includes(el));

  if (firstRun && localStorage.getItem('access_token') && !isAuthFlow) {
    dispatch(getUserInfo(history));
    if(conditions.some(el => path.includes(el)) && !path.includes("extrawallfeeds")){
      dispatch(getWidgetWallData(localStorage.getItem("ownerId"), localStorage.getItem('wallId')));
    }
    if(localStorage.getItem('ownerId'))dispatch(getWallFeeds(localStorage.getItem('ownerId')));

    if(!path.includes('admin')){
      dispatch(getAllNotification({ type: "latest", synced: 0, created: "", page: 0, perPage: 10, sortby:"message",direction:"ASC" }, true));
      dispatch(getProductAndPlanDetails());
    }
    
    if(String(studioUrl).toLowerCase().includes("studio")){
      dispatch(USER_STUDIO_WALL(localStorage.getItem("wallId")))
    }
    dispatch(updateFirstRun(false));
  }

  return <>
    {/* Auth flows hamesha LoginBasePage se chalein. BasePage `userData` null hone par kuch render
        nahi karta, aur in routes pe userData abhi hota hi nahi - isliye access_token pada hone par
        verify page blank reh jata tha aur VerifyEmail mount hi nahi hota tha. */}
    {(!localStorage.getItem('access_token') || isAuthFlow) ? <LoginBasePage history={history} /> : <BasePage getProps={getProps} history={history} />}
    <CookieConsent />
  </>
}

export default withRouter(RoutesExtends);